import {atom} from "recoil";
export const walletContractsCheckedState = atom({
  key: 'walletContractsCheckedState',
  default: [],
  effects: [
  ]
});
